'use client';

import React from 'react';
import styles from './diesel-ring-client.module.css';
import {
  HeroWithSplitBanner,
  PreFooterBanner,
  ProductCards,
  GradientTextSections,
  // SplitTextSection,
  ProductDetails,
  ImageGallery,
  LogoSection,
  IntelligentInsights,
} from 'components/uh-x-diesel';
import { VariantSelectionContextProvider } from 'components/uh-x-diesel/VariantSelectionContext';
import VariantSelectionBar from 'components/uh-x-diesel/VariantSelectionBar';
import VariantHeroSection from 'components/uh-x-diesel/VariantHeroSection';
import MobileStickyBuyButton from 'components/uh-x-diesel/MobileStickyBuyButton';
import TypekitFonts from 'components/shared/TypekitFonts';
import VideoBannerWithPlayButton from 'components/uh-x-diesel/VideoBannerWithPlayButton';

const videoMap = {
  preview: {
    web: 'web_v2/uh-x-diesel/videos/diesel-uh-loop.mp4/w_1920',
    mobile: 'web_v2/uh-x-diesel/videos/diesel-uh-loop-resp.mp4/w_1080',
  },
  video: {
    web: 'web_v2/uh-x-diesel/videos/diesel-uh-vid-w-audio.mp4/w_1920',
    mobile: 'web_v2/uh-x-diesel/videos/diesel-uh-vid-w-audio-resp.mp4/w_1080',
  },
};

const heroBannerMap = {
  background: {
    web: 'web_v2/uh-x-diesel/banners/banner-main-2.png/w_2048',
    mobile: 'web_v2/uh-x-diesel/banners/banner-main-resp-2.png/w_1920',
  },
  leftCard: {
    imagePath: 'web_v2/uh-x-diesel/banners/ring-banner-updated.png/w_1920',
  },
  rightCard: {
    imagePath: 'web_v2/uh-x-diesel/banners/banner-side-2.png/w_1920',
  },
};

const UHXDiesel = () => {
  return (
    <main>
      <TypekitFonts kits={['futura']} />
      <HeroWithSplitBanner
        bannerProps={{
          background: {
            type: 'image',
            src: {
              web: heroBannerMap.background.web,
              mobile: heroBannerMap.background.mobile,
            },
            alt: 'Diesel Ultrahuman Ring',
            // autoPlay: true,
            // loop: false,
            // muted: false,
            // playsInline: true,
            // showReplayButton: true,
          },
          // title: 'Very cool animation/video',
          // subtitle: "It's gonna be so cool!",
        }}
        leftCard={{
          title: 'Ultrahuman',
          subtitle:
            "Diesel's iconic style meets Ultrahuman's precision health technology in this limited edition smart ring.",
          imagePath: heroBannerMap.leftCard.imagePath,
        }}
        rightCard={{
          title: 'Diesel',
          subtitle:
            'Crafted for  those who carry their power and flaunt it like a bold statement.',
          imagePath: heroBannerMap.rightCard.imagePath,
        }}
      />
      <GradientTextSections
        content={`Diesel and Ultrahuman reimagine what happens when fashion's bold identity meets the clarity of precision health technology. A collaboration that pushes style ahead while grounding performance in your everyday.\n\nThis ring is designed to move with you; tuned to your energy, shaped by Diesel's attitude, powered by what your body knows.`}
      />
      <VideoBannerWithPlayButton
        // title="Even cooler animation/video"
        // subtitle="no cap, straight faxx. Gon be lit asf"
        background={{
          type: 'video',
          src: {
            web: videoMap.preview.web,
            mobile: videoMap.preview.mobile,
          },
          autoPlay: true,
          loop: true,
          muted: true,
          playsInline: true,
          visibilityThreshold: 0.1,
        }}
        playButtonVideoConfig={{
          src: {
            web: videoMap.video.web,
            mobile: videoMap.video.mobile,
          },
        }}
      />
      {/* <SplitTextSection
        leftText={'NOT YOUR EVERYDAY<br/>COLLABORATION'}
        rightText="— BUT AN EVOLUTION"
        title="Ultrahuman x Diesel"
      /> */}
      <LogoSection />
      <VariantSelectionContextProvider defaultVariant="Cryo">
        <section className={styles.buySectionContainer}>
          <VariantSelectionBar />
          <VariantHeroSection />
          <ProductDetails />
          <ImageGallery />
          <MobileStickyBuyButton />
        </section>
      </VariantSelectionContextProvider>
      <IntelligentInsights />
      <ProductCards />
      <PreFooterBanner />
    </main>
  );
};

export default UHXDiesel;
